import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { ReactNode } from "react";

type CustomizedTabsProps = {
  titles: string[] | ReactNode[];
  panels: React.ReactNode[];
  tabIndex?: number;
  onSelect?: (newTabIndex: number) => void;
};

const CustomizedTabs: React.FC<CustomizedTabsProps> = ({
  titles,
  panels,
  tabIndex,
  onSelect,
}) => {
  return (
    <Tabs
      className="mt-4 h-full flex flex-col"
      selectedIndex={tabIndex}
      onSelect={onSelect}
    >
      <TabList className="border-b-2 mb-[24px] p-0 flex gap-8px">
        {titles.map((title, index) => (
          <Tab
            className="outline-none inline-block bottom-[-1px] relative list-none cursor-pointer px-[8px] py-[6px] body-16-medium text-neutral-50"
            selectedClassName="!text-neutral-200 border-b-4 border-turquoise-50 body-16-semibold"
            key={index}
          >
            {title}
          </Tab>
        ))}
      </TabList>
      <div className="h-full">
        {panels.map((panel, index) => (
          <TabPanel key={index}>{panel}</TabPanel>
        ))}
      </div>
    </Tabs>
  );
};

export default CustomizedTabs;
